import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { District, DistrictDataService, ImportResult } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { createProvince } from "./client-province.service";

export interface DistrictOptions extends ControllerOptions<District> {}

export const initDistrict = (): District => createDistrict({});

export const createDistrict = (item: Partial<District>): District => ({
    id: item.id ?? "",
    name: item.name ?? "",
    code: item.code ?? "",
    province: item.province ?? createProvince({}),
    createdBy: item.createdBy ?? ""
});

export class ClientDistrictService extends BaseClientService implements DataController<District> {
    private _service: DistrictDataService;

    constructor() {
        super();
        this._service = new DistrictDataService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }

    public async get(options: DistrictOptions): Promise<ResultData<District>> {
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);
    }

    public async getLookup(options: DistrictOptions): Promise<ResultData<District>> {
        return await this._service.get(this.buildLookupFetchParams(options), this.token, options.filter);
    }

    public async getById(options: DistrictOptions): Promise<District | null> {
        return options.id ? await this._service.getById(options.id, this.token) : null;
    }

    public async delete(options: DistrictOptions): Promise<void> {
        if (options.id) await this._service.delete(options.id, this.token);
    }

    public async update(options: DistrictOptions): Promise<District | District[] | null> {
        return options.item?.id
            ? await this._service.update(options.item.id, options.item, this.token)
            : null;
    }

    public async add(options: DistrictOptions): Promise<District | District[] | null> {
        return options.item ? await this._service.add(options.item, this.token) : null;
    }

    public async import(options: DistrictOptions): Promise<any> {
        if (options.file) return await this._service.import(this.token, options.file);
        return null;
    }

    public async export(options: DistrictOptions): Promise<any> {
        return await this._service.export(this.token, options.filter);
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult | null> {
        return await this._service.validateName(name, this.token, id, "");
    }
}
